import { render, staticRenderFns } from "./CVTemplateButton.vue?vue&type=template&id=01d1d8b0&scoped=true&"
import script from "./CVTemplateButton.vue?vue&type=script&lang=js&"
export * from "./CVTemplateButton.vue?vue&type=script&lang=js&"
import style0 from "./CVTemplateButton.vue?vue&type=style&index=0&id=01d1d8b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1d8b0",
  null
  
)

export default component.exports